define('bootstrapper',["require", "exports", "durandal/app", "durandal/viewLocator", "durandal/system", "durandal/binder", "./models/account"], function (require, exports, App, ViewLocator, System, Binder, Account) {
    "use strict";
    var BootStrapper;
    (function (BootStrapper) {
        function run(kendo) {
            this.configure(System, Account, ko.amdTemplateEngine);
            this.start(App, ViewLocator, Binder, i18n, kendo);
        }
        BootStrapper.run = run;
        function configure(system, account, amdTemplateEngine) {
            system.debug(false);
            system.defer = function (action) {
                var deferred = Q.defer();
                action.call(deferred, deferred);
                var promise = deferred.promise;
                deferred.promise = function () { return promise; };
                return deferred;
            };
            toastr.options.positionClass = "toast-bottom-right";
            toastr.options.backgroundpositionClass = "toast-bottom-right";
            amdTemplateEngine.defaultPath = "";
            amdTemplateEngine.defaultSuffix = ".template.html";
            amdTemplateEngine.defaultRequireTextPluginName = "text";
            // breeze
            var ajaxAdapter = breeze.config.getAdapterInstance("ajax");
            ajaxAdapter.defaultSettings = {
                beforeSend: function (xhr, settings) {
                    xhr.setRequestHeader("Authorization", account.Session.getAuthorizationHeader());
                }
            };
            $.support.cors = true;
        }
        BootStrapper.configure = configure;
        function start(app, viewLocator, binder, i18next, kendo) {
            var _this = this;
            app.configurePlugins({
                router: true,
                dialog: true,
                widget: {
                    kinds: ["dataList", "dataGrid", "simpleView", "pagedView"]
                }
            });
            app.start()
                .then(function () {
                viewLocator.useConvention("viewmodels", "views", "areas");
                kendo.ns = "kendo-";
                binder.beforeBind = function (obj, view) {
                    kendo.bind(view, obj.viewModel);
                };
                //Call localization on view before binding...
                binder.bindingComplete = function (obj, view) {
                    $(view).i18n();
                };
                var options = _this.getI18NOptions();
                moment.locale(options.lng);
                i18next.init(options, function () {
                    // start the app
                    app.setRoot("areas/home/viewmodels/shell");
                });
            });
        }
        BootStrapper.start = start;
        function getI18NOptions() {
            // needed for FF. no userLanguage exists
            var language = "en";
            var fallbackLanguage = "en";
            var i18NOptions = {
                detectFromHeaders: false,
                lng: language,
                fallbackLng: fallbackLanguage,
                ns: "app",
                resGetPath: "locales/__lng__/__ns__.json",
                useCookie: false
            };
            return i18NOptions;
        }
        BootStrapper.getI18NOptions = getI18NOptions;
    })(BootStrapper || (BootStrapper = {}));
    return BootStrapper;
});

